<template>
  <div class="cimg1" >    
            <!-- <div class="leftBtn" @click="imgClick('left')">&lt;</div> -->
            <transition>
                <img class="cimg2" :key="imgIndex" :src="currentImageSrc" />                
            </transition>
            <!-- <div class="rightBtn" @click="imgClick('right')">></div> -->
        </div>
</template>

<script>
  export default {  
    props: ['carouselFolder'], 
    data() {
      return {
        images: [],
        imgIndex: 0,
        timer1:'',  
        cf1: this.cf,
      }
    },
    computed: {
      folderName() {
        return this.carouselFolder || 'pancake-scroll';
      },
      currentImageSrc() {
        if (this.images.length > 0) {
          return `/gallery/${this.folderName}/${this.images[this.imgIndex]}`;
        }
        return '';
      },
    },
    methods: {
      setTimer() {
          this.timer1=setInterval(() => {
              this.rightClick();
          },3000);
      },
      leftClick(){
          if(this.imgIndex === 0){
              this.imgIndex = this.images.length -1;
          } else {
              this.imgIndex = this.imgIndex - 1;
          }
      },
      rightClick(){
          if(this.imgIndex===(this.images.length-1)){
              this.imgIndex = 0;
          } else {
              this.imgIndex = this.imgIndex + 1;
          }
      },
    },
    async mounted() {
      try {
        const res = await fetch(`/gallery/${this.folderName}/manifest.json`);
        this.images = await res.json();
      } catch (e) {
        console.error('Failed to load manifest', e);
      }
      this.setTimer();
    },
  }
  
</script>

<style scoped>
  .cimg1{
    /* display:flex;    
    justify-content: center;
    align-items: center; */
    /* width:45%; */
    /* height:00px; */
    /* width:100%; */
    /* height:calc(vh - 180px); */
    position:relative;
    display:grid;
    grid-template-columns: 1fr;
  }
  .cimg2 {  
    /* width:100%; */    
    height:calc(50vh + 24vw - 80px);
    transition: all 1s ease;        
    grid-row-start:1;
    grid-column-start:1;
    position:relative;    
    z-index:1;
  }
  .v-enter-active {
    opacity:0;
    z-index:10;
  }
  .v-leave-active {
      opacity:1;    
      z-index:1;
  }

  .v-enter, .v-leave-to {
      opacity:0;
  }
  .v-leave, .v-enter-to {
      opacity:1;
  }
  @media only screen and (max-width: 1152px) {    
    .img1 {      
    }
    .cimg1 {      
    }
    .cimg2 {
      height:auto;
      max-height:150vh;
      max-width:100%;
      margin-left:auto;
      margin-right:auto;
    }
  }
</style>
